module.exports = __webpack_public_path__ + "static/media/YB5F12_5.4838a661.jpg";